import 'jquery-confirm'
import { Notyf } from 'notyf'

bookingHub.notyf = new Notyf({
  duration: 1500,
  ripple: false,
  types: [
    {
      type: 'success',
      background: '#151C21',
    },
    {
      type: 'error',
      background: '#E11B1A',
    },
  ],
})
